<div class="carspec" [ngClass]="{'carspec_en': lang == 'en'}">
  <div class="inner_carspec_contents">
    <h2 class="t_head txtalcenter">{{ lang | i18nSelect: strings.carSpec.specTitle }}</h2>
    <div class="wrapper">
      <div class="inner_wrapper">
        <div class="spec_wrapper">
          <table>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.modelYear }}</th>
              <td>{{ car.modelYear }}<span class="format" *ngIf="car.modelYear">{{ lang | i18nSelect: strings.carSpec.modelYearSuffix }}</span></td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.firstYear }}</th>
              <td [innerHTML]="car.firstYearMonth | dateDecoration | safeHTML"></td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.displacement }}</th>
              <td>{{ car.displacement }}<span class="format" *ngIf="car.displacement">cc</span></td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.distance }}</th>
              <td>{{ car.distance }}<span class="format" *ngIf="car.distance">km</span></td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.manualTransmission }}</th>
              <td>{{ car.manualTransmission }}</td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.steeringWheel }}</th>
              <td>{{ car.steeringWheel }}</td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.color }}</th>
              <td>{{ car.color }}</td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.chassisNumber }}</th>
              <td>{{ car.chassisNumber }}</td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.engineNumber }}</th>
              <td>{{ car.engineNumber }}</td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.vehicleInspection }}</th>
              <td [innerHTML]="(car.vehicleInspection | dateDecoration | safeHTML) || '&nbsp;'"></td>
            </tr>
            <tr>
              <th>{{ lang | i18nSelect: strings.carSpec.area }}</th>
              <td>{{ car.area || '&nbsp;' }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
